;(function () {
	const initProductAccordion = () => {
		const aboutToggleItems = $('.about__accordion-toggle')

		aboutToggleItems.each(function () {
			const currentToggle = $(this)
			const siblingToggles = currentToggle.siblings(
				'.about__accordion-description'
			)

			currentToggle.click(function () {
				if (!currentToggle.hasClass('active')) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this)
						siblingToggle.removeClass('active')
						siblingToggle
							.siblings('.about__accordion-description')
							.stop()
							.slideUp(300)
					})

					currentToggle.addClass('active')

					siblingToggles.stop().slideDown(300)
				} else {
					currentToggle.removeClass('active')
					siblingToggles.stop().slideUp(300)
				}
			})
		})
	}

	// 初始化产品变体选择
	document.addEventListener('DOMContentLoaded', function() {
		console.log('页面加载完成，初始化产品变体选择...');
		// 延迟一点点执行，确保所有DOM元素都已加载
		setTimeout(() => {
			initVariantCards();
		}, 10);
	});

	// 立即执行一次变体卡片初始化
	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		console.log('页面已经加载，立即初始化变体卡片...');
		setTimeout(() => {
			initVariantCards();
		}, 10);
	}

	// 初始化产品变体卡片选择处理
	function initVariantCards() {
		const variantOptions = document.querySelectorAll('.product-variant-option');
		if (!variantOptions.length) return;

		console.log('初始化变体卡片...');
		
		// 为第二个变体设置正确的折扣数据
		if (variantOptions.length > 1) {
			const secondVariant = variantOptions[1];
			
			// 确保数据属性正确设置
			const currentPrice = secondVariant.querySelector('.product-variant-current-price');
			const comparePrice = secondVariant.querySelector('.product-variant-compare-price');
			
			if (currentPrice && comparePrice) {
				// 从显示的价格中提取数值
				const currentPriceValue = parseFloat(currentPrice.textContent.replace(/[^\d.]/g, ''));
				const comparePriceValue = parseFloat(comparePrice.textContent.replace(/[^\d.]/g, ''));
				
				if (currentPriceValue > 0) {
					// 设置价格数据属性
					secondVariant.setAttribute('data-price', currentPriceValue * 100);
					secondVariant.setAttribute('data-compare-price', comparePriceValue * 100);
				}
			}
		}
		
		// 设置卡片点击事件
		variantOptions.forEach(option => {
			option.addEventListener('click', function(event) {
				event.preventDefault();
				
				// 获取对应的单选按钮
				const radio = this.querySelector('input[type="radio"]');
				
				// 获取父级fieldset
				const fieldset = this.closest('fieldset');
				if (!fieldset) return;
				
				// 移除同组中其他选项的选中状态
				const siblingOptions = fieldset.querySelectorAll('.product-variant-option');
				siblingOptions.forEach(opt => opt.classList.remove('selected'));
				
				// 添加当前选项的选中状态
				this.classList.add('selected');
				
				console.log('选择了变体: ', this.getAttribute('data-variant-value'));
				
				// 选中对应的单选按钮并触发change事件
				if (radio) {
					radio.checked = true;
					radio.dispatchEvent(new Event('change', { bubbles: true }));
					
					// 更新主图片 - 找到对应的变体并显示其图片
					updateProductMainImage(radio);
					
					// 更新加购表单中的变体ID
					updateVariantIdInForms(this);
					
					// 更新价格显示
					updateProductPrice(this);
				}
			});
		});
		
		// 确保折扣徽章正确显示（确保DOM渲染完成后再执行）
		setTimeout(ensureDiscountBadgesVisible, 0);
		
		// 尝试根据URL参数选择变体
		const urlParams = new URLSearchParams(window.location.search);
		const variantId = urlParams.get('variant');
		
		let selectedVariant = false;
		
		if (variantId) {
			// 查找对应的变体选项
			const variantOption = document.querySelector(`.product-variant-option[data-variant-id="${variantId}"]`);
			if (variantOption) {
				variantOption.click();
				selectedVariant = true;
				console.log('通过URL参数选择了变体:', variantId);
			}
		}
		
		// 如果没有从URL选择变体，则选择第一个变体
		if (!selectedVariant && variantOptions.length > 0) {
			// 找到第一个变体并点击它
			const firstOption = variantOptions[0];
			if (firstOption) {
				firstOption.click();
				console.log('选择了第一个默认变体');
			}
		}
	}
	
	// 更新产品价格显示
	function updateProductPrice(optionElement) {
		if (!optionElement) return;
		
		// 获取选中变体的价格和比较价格
		const price = optionElement.getAttribute('data-price');
		const comparePrice = optionElement.getAttribute('data-compare-price');
		
		if (!price) return;
		
		// 格式化价格
		const formattedPrice = formatMoney(price);
		
		// 更新产品价格显示
		const priceElements = document.querySelectorAll('.price__regular .price-item--regular');
		priceElements.forEach(element => {
			element.textContent = formattedPrice;
		});
		
		// 更新比较价格（如果有）
		if (comparePrice && comparePrice > price) {
			const formattedComparePrice = formatMoney(comparePrice);
			const comparePriceElements = document.querySelectorAll('.price__sale .price-item--regular, .price__compare .price-item--regular');
			comparePriceElements.forEach(element => {
				element.textContent = formattedComparePrice;
			});
			
			// 显示特价标签
			const priceWrapper = document.querySelector('.price-wrapper');
			if (priceWrapper) {
				priceWrapper.classList.add('price--on-sale');
			}
		} else {
			// 隐藏特价标签
			const priceWrapper = document.querySelector('.price-wrapper');
			if (priceWrapper) {
				priceWrapper.classList.remove('price--on-sale');
			}
		}
		
		// 检查是否有折扣百分比数据
		const discount = optionElement.getAttribute('data-discount');
		if (discount && parseInt(discount) > 0) {
			// 尝试找到并更新产品价格部分的折扣显示
			const saleLabel = document.querySelector('.price__badge--sale');
			if (saleLabel) {
				saleLabel.textContent = `${discount}% OFF`;
				saleLabel.classList.remove('hidden');
			}
		} else {
			// 如果没有折扣，隐藏折扣标签
			const saleLabel = document.querySelector('.price__badge--sale');
			if (saleLabel) {
				saleLabel.classList.add('hidden');
			}
		}
	}
	
	// 格式化金额为货币格式
	function formatMoney(cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}
		
		const value = parseInt(cents || 0) / 100;
		const formatString = format || '${{amount}}';
		
		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = precision || 2;
			thousands = thousands || ',';
			decimal = decimal || '.';
			
			const numberStr = (number || 0).toFixed(precision);
			
			const parts = numberStr.split('.');
			const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
			const centsAmount = parts[1] ? (decimal + parts[1]) : '';
			
			return dollarsAmount + centsAmount;
		}
		
		const formatMappings = {
			'amount': formatWithDelimiters(value, 2),
			'amount_no_decimals': formatWithDelimiters(value, 0),
			'amount_with_comma_separator': formatWithDelimiters(value, 2, '.', ','),
			'amount_no_decimals_with_comma_separator': formatWithDelimiters(value, 0, '.', ','),
			'amount_with_space_separator': formatWithDelimiters(value, 2, ' ', '.')
		};
		
		let formattedMoney = formatString;
		
		for (const mapping in formatMappings) {
			formattedMoney = formattedMoney.replace(`{{${mapping}}}`, formatMappings[mapping]);
		}
		
		return formattedMoney;
	}
	
	// 确保折扣徽章正确显示
	function ensureDiscountBadgesVisible() {
		document.querySelectorAll('.product-variant-option').forEach(option => {
			// 获取价格和比较价格
			const price = parseInt(option.getAttribute('data-price') || 0);
			const comparePrice = parseInt(option.getAttribute('data-compare-price') || 0);
			
			// 如果价格为0，可能是初始化状态，检查元素内的价格信息
			if (price === 0 && comparePrice === 0) {
				const currentPriceEl = option.querySelector('.product-variant-current-price');
				const comparePriceEl = option.querySelector('.product-variant-compare-price');
				
				if (currentPriceEl && comparePriceEl) {
					// 提取价格文本中的数字部分
					const currentPriceText = currentPriceEl.textContent.trim().replace(/[^\d.]/g, '');
					const comparePriceText = comparePriceEl.textContent.trim().replace(/[^\d.]/g, '');
					
					// 转换为数字
					const currentPrice = parseFloat(currentPriceText) * 100;
					const oldComparePrice = parseFloat(comparePriceText) * 100;
					
					if (currentPrice > 0 && oldComparePrice > currentPrice) {
						// 计算折扣百分比
						const discountPercent = Math.round((1 - currentPrice / oldComparePrice) * 100);
						
						if (discountPercent > 0) {
							// 更新属性
							option.setAttribute('data-price', currentPrice);
							option.setAttribute('data-compare-price', oldComparePrice);
							option.setAttribute('data-discount', discountPercent);
							
							console.log(`从价格文本更新变体 ${option.getAttribute('data-variant-value')} 的折扣: ${discountPercent}%`);
							
							// 添加折扣徽章
							let badge = option.querySelector('.product-variant-discount-badge');
							if (!badge) {
								badge = document.createElement('span');
								badge.className = 'product-variant-discount-badge';
								badge.textContent = `${discountPercent}% OFF`;
								option.insertBefore(badge, option.firstChild);
							} else {
								badge.textContent = `${discountPercent}% OFF`;
							}
						}
					}
				}
			} else {
				// 使用直接设置的属性
				const discount = parseInt(option.getAttribute('data-discount') || 0);
				
				// 查找折扣徽章
				let badge = option.querySelector('.product-variant-discount-badge');
				
				// 如果有折扣但没有徽章，创建一个
				if (discount > 0 && !badge) {
					badge = document.createElement('span');
					badge.className = 'product-variant-discount-badge';
					badge.textContent = `${discount}% OFF`;
					option.insertBefore(badge, option.firstChild);
					console.log(`为变体 ${option.getAttribute('data-variant-value')} 添加了折扣徽章: ${discount}%`);
				} 
				// 如果有徽章但没有折扣，移除徽章
				else if (discount <= 0 && badge) {
					badge.remove();
				}
			}
		});
		
		// 延迟一下再次检查，确保所有徽章都正确显示
		setTimeout(() => {
			document.querySelectorAll('.product-variant-option').forEach(option => {
				// 尝试再次从价格计算折扣
				const currentPriceEl = option.querySelector('.product-variant-current-price');
				const comparePriceEl = option.querySelector('.product-variant-compare-price');
				
				if (currentPriceEl && comparePriceEl) {
					// 提取价格文本中的数字部分
					const currentPriceText = currentPriceEl.textContent.trim().replace(/[^\d.]/g, '');
					const comparePriceText = comparePriceEl.textContent.trim().replace(/[^\d.]/g, '');
					
					// 转换为数字
					const currentPrice = parseFloat(currentPriceText) * 100;
					const oldComparePrice = parseFloat(comparePriceText) * 100;
					
					if (currentPrice > 0 && oldComparePrice > currentPrice) {
						// 计算折扣百分比
						const discountPercent = Math.round((1 - currentPrice / oldComparePrice) * 100);
						
						if (discountPercent > 0) {
							// 更新徽章或创建新徽章
							let badge = option.querySelector('.product-variant-discount-badge');
							if (!badge) {
								badge = document.createElement('span');
								badge.className = 'product-variant-discount-badge';
								badge.textContent = `${discountPercent}% OFF`;
								option.insertBefore(badge, option.firstChild);
								console.log(`再次尝试添加折扣徽章: ${discountPercent}%`);
							}
						}
					}
				}
			});
		}, 100);
	}
	
	// 根据选择的选项找到对应的变体ID，并更新加购表单中的变体ID
	function updateVariantIdInForms(selectedOption) {
		if (!selectedOption) return;
		
		// 尝试直接从选项元素获取变体ID
		const variantId = selectedOption.getAttribute('data-variant-id');
		
		if (variantId) {
			// 更新所有产品表单的变体ID输入字段
			document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(input => {
				input.value = variantId;
				console.log('已更新加购表单变体ID为:', variantId);
			});
		}
	}
	
	// 根据选择的变体更新产品主图
	function updateProductMainImage(radioInput) {
		if (!radioInput) return;
		
		// 从选择的变体元素获取信息
		const optionValue = radioInput.value;
		const optionName = radioInput.name.replace('options[', '').replace(']', '');
		
		// 在其他变体选项中找到对应的选中值
		const allOptionInputs = document.querySelectorAll('input[type="radio"]:checked');
		const selectedOptions = Array.from(allOptionInputs).map(input => {
			const name = input.name.replace('options[', '').replace(']', '');
			return {
				name: name,
				value: input.value
			};
		});
		
		console.log('选中的选项:', selectedOptions);
		
		// 从不同可能的位置获取变体JSON数据
		let variantData = null;
		try {
			// 尝试从主变体选择器获取
			const variantJson = document.querySelector('variant-radios script, variant-selects script');
			if (variantJson) {
				variantData = JSON.parse(variantJson.textContent);
			}
			
			// 如果主变体选择器没有数据，尝试从其他可能的位置获取
			if (!variantData) {
				const variantOptionsData = document.querySelector('.variant-options-data');
				if (variantOptionsData) {
					variantData = JSON.parse(variantOptionsData.textContent);
				}
			}
			
			// 如果还是没有找到，尝试从产品JSON数据中获取
			if (!variantData) {
				const productJson = document.querySelector('#ProductJSON-' + document.querySelector('[data-product-id]')?.dataset?.productId);
				if (productJson) {
					const productData = JSON.parse(productJson.textContent);
					if (productData && productData.variants) {
						variantData = productData.variants;
					}
				}
			}
			
			// 如果仍然没有找到，给出明确的提示
			if (!variantData || !Array.isArray(variantData) || variantData.length === 0) {
				console.warn('未找到产品变体数据，请确保页面包含变体JSON数据');
				return;
			}
			
			console.log('所有变体:', variantData);
			
			// 找到匹配所有当前选中选项的变体
			let matchedVariant = null;
			
			// 首先尝试精确匹配所有选项
			matchedVariant = variantData.find(variant => {
				return selectedOptions.every(option => {
					const optionIndex = variant.options.findIndex(
						(opt, idx) => variant.option_names && variant.option_names[idx] === option.name
					);
					return optionIndex >= 0 && variant.options[optionIndex] === option.value;
				});
			});
			
			// 如果没有精确匹配，尝试匹配当前选中的选项
			if (!matchedVariant) {
				matchedVariant = variantData.find(variant => {
					const currentOptionIndex = variant.options.findIndex(
						(opt, idx) => variant.option_names && variant.option_names[idx] === optionName
					);
					return currentOptionIndex >= 0 && variant.options[currentOptionIndex] === optionValue;
				});
			}
			
			// 如果还是没有匹配，尝试匹配部分选项
			if (!matchedVariant) {
				for (const opt of selectedOptions) {
					matchedVariant = variantData.find(variant => {
						const optIdx = variant.option_names 
							? variant.option_names.indexOf(opt.name)
							: variant.options.indexOf(opt.value);
						return optIdx >= 0 && variant.options[optIdx] === opt.value;
					});
					if (matchedVariant) break;
				}
			}
			
			// 最后尝试，如果还是找不到，使用第一个可用变体
			if (!matchedVariant && variantData.length > 0) {
				matchedVariant = variantData.find(v => v.available) || variantData[0];
			}
			
			console.log('匹配的变体:', matchedVariant);
			
			// 如果找到匹配的变体
			if (matchedVariant) {
				// 检查变体的各种图片属性
				console.log('变体图片信息:', {
					'featured_image': matchedVariant.featured_image,
					'image': matchedVariant.image,
					'featured_media': matchedVariant.featured_media
				});
				
				// 提取图片ID - 尝试多种属性
				let imageId = null;
				let imageUrl = null;
				
				// 尝试获取图片ID
				if (matchedVariant.featured_image && matchedVariant.featured_image.id) {
					imageId = matchedVariant.featured_image.id;
					imageUrl = matchedVariant.featured_image.src;
				} else if (matchedVariant.image && matchedVariant.image.id) {
					imageId = matchedVariant.image.id;
					imageUrl = matchedVariant.image.src;
				} else if (matchedVariant.featured_media && matchedVariant.featured_media.id) {
					imageId = matchedVariant.featured_media.id;
				}
				
				// 添加额外尝试，从其他字段获取图片URL
				if (!imageUrl && matchedVariant.featured_image && matchedVariant.featured_image.url) {
					imageUrl = matchedVariant.featured_image.url;
				} else if (!imageUrl && matchedVariant.image && matchedVariant.image.url) {
					imageUrl = matchedVariant.image.url;
				}
				
				console.log('图片ID:', imageId, '图片URL:', imageUrl);
				
				// 找到所有媒体项，然后选择匹配当前变体的图片
				const mediaItems = document.querySelectorAll('.product__media-item');
				console.log('可用媒体项:', mediaItems);
				
				let found = false;
				
				// 方法1: 通过图片ID尝试匹配
				if (imageId) {
					mediaItems.forEach(item => {
						const mediaId = item.dataset.mediaId;
						console.log('检查媒体项ID:', mediaId);
						
						// 扩展匹配条件，使用更灵活的匹配方式
						if (mediaId && (
							mediaId.endsWith(`-${imageId}`) || 
							mediaId.includes(`-${imageId}-`) || 
							mediaId.includes(`${imageId}`) ||
							String(mediaId) === String(imageId)
						)) {
							console.log('通过ID找到匹配的媒体项:', mediaId);
							found = true;
							switchToMediaItem(item, mediaItems);
						}
					});
				}
				
				// 方法2: 如果ID匹配失败，尝试通过数值部分匹配
				if (!found && imageId) {
					const imageIdNumber = String(imageId).replace(/\D/g, '');
					mediaItems.forEach(item => {
						const mediaId = item.dataset.mediaId;
						if (mediaId) {
							const mediaIdNumber = String(mediaId).replace(/\D/g, '');
							if (mediaIdNumber === imageIdNumber) {
								console.log('通过数字ID找到匹配的媒体项:', mediaId);
								found = true;
								switchToMediaItem(item, mediaItems);
							}
						}
					});
				}
				
				// 方法3: 如果仍未找到，尝试通过URL匹配
				if (!found && imageUrl) {
					console.log('尝试通过URL匹配图片');
					document.querySelectorAll('.product__media img').forEach(img => {
						if (found) return;
						
						const imgSrc = img.src || img.getAttribute('data-src') || '';
						const imgAlt = img.alt || '';
						
						// 尝试多种方式匹配图片
						const isUrlMatch = 
							(imageUrl && imgSrc && (
								imgSrc.includes(imageUrl) || 
								imageUrl.includes(imgSrc) ||
								// 比较URL的文件名部分
								imgSrc.split('/').pop().includes(imageUrl.split('/').pop()) ||
								imageUrl.split('/').pop().includes(imgSrc.split('/').pop())
							));
							
						// 尝试通过变体标题匹配图片alt文本
						const isTitleMatch = matchedVariant.title && imgAlt && 
							(imgAlt.includes(matchedVariant.title) || matchedVariant.title.includes(imgAlt));
						
						if (isUrlMatch || isTitleMatch) {
							console.log('通过URL或标题匹配到图片:', imgSrc);
							found = true;
							const parentMedia = img.closest('.product__media-item');
							if (parentMedia) {
								switchToMediaItem(parentMedia, mediaItems);
							}
						}
					});
				}
				
				// 方法4: 最后尝试匹配变体选项值与图片alt文本
				if (!found && selectedOptions.length > 0) {
					document.querySelectorAll('.product__media img').forEach(img => {
						if (found) return;
						
						const imgAlt = img.alt || '';
						// 检查图片alt是否包含任何选项值
						for (const option of selectedOptions) {
							if (imgAlt.includes(option.value)) {
								console.log('通过选项值匹配到图片:', imgAlt, option.value);
								found = true;
								const parentMedia = img.closest('.product__media-item');
								if (parentMedia) {
									switchToMediaItem(parentMedia, mediaItems);
								}
								break;
							}
						}
					});
				}
				
				// 如果所有尝试都失败，回退到默认显示第一张图片
				if (!found && mediaItems.length > 0) {
					console.log('无法找到匹配图片，显示默认第一张图片');
					switchToMediaItem(mediaItems[0], mediaItems);
				}
				
			} else {
				console.warn('无法找到匹配的变体，请检查变体配置');
			}
		} catch (error) {
			console.error('解析变体数据错误:', error);
		}
	}
	
	// 辅助函数：切换到指定的媒体项
	function switchToMediaItem(item, allItems) {
		// 对应 Swiper 幻灯片时
		const swiperSlider = document.querySelector('.product__media-list.swiper');
		if (swiperSlider && window.Swiper && swiperSlider.swiper) {
			const swiperInstance = swiperSlider.swiper;
			const slideIndex = Array.from(allItems).findIndex(slide => slide === item);
			if (slideIndex >= 0) {
				console.log('滑动到幻灯片索引:', slideIndex);
				swiperInstance.slideTo(slideIndex);
			}
		} else {
			// 对于非 Swiper 的情况
			allItems.forEach(media => {
				media.style.display = 'none';
			});
			item.style.display = 'block';
		}
	}

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			'.product-media-modal__content'
		)
		const images = imagesWrapper?.querySelectorAll('.js-image-zoom') || []

		images.forEach((el) => {
			el.addEventListener('click', (e) => {
				imagesWrapper.classList.toggle('zoom')
			})
		})
	}

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
		const formatString = theme.moneyFormat

		return formatString.replace(placeholderRegex, value)
	}

	const setTotalFreeShipping = () => {
		if (document.querySelector('.js-free-shipping')) {
			const freeShippingTotal = document.querySelector('.free-shipping-total')
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend)
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`
				}
			}
		}
	}
	function changeIconsViewBox() {
		const textWithIcon = document.querySelectorAll('.text_with_icon')
		textWithIcon.forEach((item) => {
			const icons = item.querySelectorAll('.icon-pack')
			icons.forEach((icon) => {
				icon.setAttribute('viewBox', '0 0 20 20')
			})
		})
	}

	//document.addEventListener('scroll', () => {
	//	const navigation = document.querySelector('.product__media_navigation')
	//	if (navigation) {
	//		const footer = document.querySelector('.footer')
	//		const navigationHeight = navigation.offsetHeight
	//		const screen = window.scrollY
	//		const overview = document.querySelector('#overview').scrollTop
	//		const overviewBottom =
	//			document.querySelector('#overview').clientHeight + overview
	//		if (screen >= overview && screen <= overviewBottom) {
	//			document.querySelector('#overview-link').classList.add('active')
	//		} else {
	//			document.querySelector('#overview-link').classList.remove('active')
	//		}
	//		if (window.innerHeight + screen - navigationHeight > footer.offsetTop) {
	//			navigation.style.opacity = '0'
	//			navigation.style.visibility = 'hidden'
	//		} else {
	//			navigation.style.opacity = '1'
	//			navigation.style.visibility = 'visible'
	//		}
	//	}
	//})

	const navigationSections = [
		{
			sectionSelector: '#overview',
			linkSelector: '#overview-link',
		},
		{
			sectionSelector: '#product-specifications',
			linkSelector: '#specifications-link',
		},
	]

	function navigationInit(sections) {
		const navigation = document.querySelector('.product__media_navigation')
		if (navigation) {
			navigation.style.transform = 'translateX(-50%) translateY(calc(100% + 16px))'
		}
		document.addEventListener('scroll', () => {
			if (navigation) {
				navigation.classList.add('show-navigation')
			}
			if (navigation) {
				const footer = document.querySelector('.footer')
				const navigationHeight = navigation.offsetHeight
				const secondSection = document.querySelectorAll('#MainContent .shopify-section')[1]
				const screen = window.scrollY
				sections.forEach((section, i) => {
					if (section) {
						const em = document.querySelector(`${section.sectionSelector}`)
						if (em) {
							const rect = em.getBoundingClientRect()	
							if (rect.top <= 1 && rect.top > rect.height * -1) {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.add('active')
							} else {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.remove('active')
							}
							document.querySelector(`${section.linkSelector}`).addEventListener('click', () => {
								em.scrollIntoView({ behavior: 'smooth' });
							})
						} else {
							document.querySelector(`${section.linkSelector}`).style.display = 'none';
						}
					}
				})
				
				const rect = secondSection.getBoundingClientRect();
				const isSecondSectionScrolled = rect.top < 0;
				const isNearFooter = window.innerHeight + screen - navigationHeight > footer.offsetTop;

				navigation.style.transform = isSecondSectionScrolled && !isNearFooter
				? 'translateX(-50%) translateY(0)'
				: 'translateX(-50%) translateY(calc(100% + 16px))';
			}
		})
	}

	// 移除导航栏中加购按钮的提示点
	function removeCartButtonDot() {
		const navigationCartButton = document.querySelector('.product__media_navigation .product-form__submit.dot_active');
		if (navigationCartButton) {
			// 只移除视觉效果而不移除类
			const style = document.createElement('style');
			style.textContent = `
				.product__media_navigation .product-form__submit.dot_active:before,
				.product__media_navigation .product-form__submit.dot_active:after {
					display: none !important;
				}
			`;
			document.head.appendChild(style);
		}
	}

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion()
		initZoomImage()
		setTotalFreeShipping()
		changeIconsViewBox()
		navigationInit(navigationSections)
		removeCartButtonDot()
		initVariantCards()
	})

	navigationInit(navigationSections)
	initProductAccordion()
	initZoomImage()
	setTotalFreeShipping()
	changeIconsViewBox()
	removeCartButtonDot()
	initVariantCards()
})();

// 配件选择功能 - 使用Shopify官方API
(function() {
	/**
	 * 初始化配件选择功能
	 */
	function initAccessories() {
		// 获取所有配件选项和加购表单
		const options = document.querySelectorAll('.product-accessory-option');
		const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
		
		if (!options.length || !forms.length) return;
		
		// 清理旧表单事件处理
		forms.forEach(form => {
			const clone = form.cloneNode(true);
			form.parentNode.replaceChild(clone, form);
		});
		
		// 重新获取新表单
		const newForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
		
		// 设置配件选项点击事件
		options.forEach(option => {
			option.onclick = function() {
				options.forEach(opt => opt.classList.remove('selected'));
				this.classList.add('selected');
				
				const radio = this.querySelector('.product-accessory-input');
				if (radio) radio.checked = true;
			};
		});
		
		// 默认选中第一个配件
		if (options.length > 0) {
			options[0].classList.add('selected');
			const firstRadio = options[0].querySelector('.product-accessory-input');
			if (firstRadio) firstRadio.checked = true;
		}
		
		// 设置加购表单提交事件
		newForms.forEach(form => {
			form.onsubmit = function(e) {
				e.preventDefault();
				
				// 设置按钮加载状态
				const submitButton = form.querySelector('.product-form__submit');
				if (submitButton) {
					const spinner = submitButton.querySelector('.loading-overlay__spinner');
					if (spinner) spinner.classList.remove('hidden');
					submitButton.setAttribute('disabled', 'disabled');
				}
				
				// 执行加购操作
				addToCart(form, submitButton);
			};
		});
	}
	
	/**
	 * 添加商品到购物车
	 * 使用Shopify官方推荐的API: https://shopify.dev/api/ajax/reference/cart
	 */
	function addToCart(form, submitButton) {
		// 获取主商品信息
		const formData = new FormData(form);
		const mainProductId = formData.get('id');
		const quantity = parseInt(formData.get('quantity') || 1);
		
		// 准备商品数组
		const items = [
			{
				id: mainProductId,
				quantity: quantity
			}
		];
		
		// 获取选中的配件
		const selectedOption = document.querySelector('.product-accessory-option.selected');
		if (selectedOption) {
			const accessoryRadio = selectedOption.querySelector('.product-accessory-input');
			if (accessoryRadio && accessoryRadio.value) {
				items.push({
					id: accessoryRadio.value,
					quantity: 1
				});
			}
		}
		
		// 使用Shopify Cart API添加商品
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ items: items })
		})
		.then(response => response.json())
		.then(data => {
			if (data.status) {
				throw new Error(data.description || '添加到购物车失败');
			}
			
			// 成功添加后，更新购物车数量并打开抽屉
			updateCartCount();
			openCartDrawer();
		})
		.catch(error => {
			console.error('添加到购物车失败:', error);
			alert('添加到购物车失败: ' + error.message);
		})
		.finally(() => {
			// 恢复按钮状态
			if (submitButton) {
				const spinner = submitButton.querySelector('.loading-overlay__spinner');
				if (spinner) spinner.classList.add('hidden');
				submitButton.removeAttribute('disabled');
			}
		});
	}
	
	/**
	 * 更新购物车数量
	 * 使用Shopify官方Cart API获取最新购物车数据
	 */
	function updateCartCount() {
		fetch('/cart.js')
			.then(response => response.json())
			.then(cart => {
				// 更新页面顶部的购物车计数器
				const cartCountBubble = document.querySelector('.header__icon--cart .cart-count-bubble');
				if (cartCountBubble) {
					const cartCount = cartCountBubble.querySelector('span');
					if (cartCount) {
						cartCount.textContent = cart.item_count;
					}
					
					// 处理显示/隐藏逻辑
					if (cart.item_count === 0) {
						cartCountBubble.classList.add('hidden');
					} else {
						cartCountBubble.classList.remove('hidden');
					}
				}
				
				// 获取所有可能的购物车计数元素并更新数量
				const cartCountElements = document.querySelectorAll('.cart-count');
				cartCountElements.forEach(element => {
					element.textContent = cart.item_count;
				});
				
				// 更新购物车图标中的数量，但不替换整个图标DOM
				const cartIconBubble = document.getElementById('cart-icon-bubble');
				if (cartIconBubble) {
					// 找到购物车图标中的数量元素
					const countElement = cartIconBubble.querySelector('.cart-count-bubble span');
					if (countElement) {
						// 更新数量文本
						countElement.textContent = cart.item_count;
						
						// 更新显示/隐藏状态
						const bubble = countElement.closest('.cart-count-bubble');
						if (bubble) {
							if (cart.item_count === 0) {
								bubble.classList.add('hidden');
							} else {
								bubble.classList.remove('hidden');
							}
						}
					}
				}
			})
			.catch(error => {
				console.error('获取购物车数据失败:', error);
			});
	}
	
	/**
	 * 打开购物车抽屉
	 */
	function openCartDrawer() {
		// 获取购物车抽屉HTML
		fetch('?section_id=cart-drawer')
			.then(response => response.text())
			.then(html => {
				const cartDrawer = document.querySelector('cart-drawer');
				if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
					cartDrawer.renderContents({
						sections: {
							'cart-drawer': html,
							'cart-icon-bubble': document.querySelector('#cart-icon-bubble')?.outerHTML || ''
						}
					});
					
					// 打开购物车抽屉
					setTimeout(() => {
						if (typeof cartDrawer.open === 'function') {
							cartDrawer.open();
						}
					}, 100);
				}
			})
			.catch(error => {
				console.error('更新购物车抽屉失败:', error);
			});
	}
	
	// 初始化功能
	function init() {
		initAccessories();
	}
	
	// 页面加载完成后初始化
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
	
	// Shopify部分刷新后重新初始化
	document.addEventListener('shopify:section:load', function() {
		setTimeout(init, 100);
	});
})(); 